// F1 App-Shell (TES-948): Mobile Top App Bar (screen-09 / screen-06).
// h-16 sticky bg-surface border-b border-outline-variant. Hamburger (menu)
// oeffnet den NavDrawer; Breadcrumb-Slot + NotificationBell + Avatar/User-Menu.
// data-tour="notification-bell" verlustfrei erhalten.
import { Menu } from "lucide-react";
import { Button } from "@/components/ui/button";
import { NotificationBell } from "@/components/notifications/NotificationBell";
import { AppBreadcrumb } from "../AppBreadcrumb";
import type { ShellModel } from "./useShellModel";
import { UserMenu } from "./UserMenu";

interface MobileTopBarProps {
  model: ShellModel;
  onOpenMenu: () => void;
}

export function MobileTopBar({ model, onOpenMenu }: MobileTopBarProps) {
  const { t } = model;

  // shrink-0 am <header> (TES-1683): wie TopAppBar — verhindert das Schrumpfen der h-16-Leiste
  // im flex-col `main` bei content-schweren Seiten (sonst springt die Header-Höhe).
  return (
    <header
      data-testid="mobile-top-bar"
      className="md:hidden shrink-0 sticky top-0 z-50 flex items-center justify-between gap-2 h-16 w-full px-4 bg-surface border-b border-outline-variant"
    >
      <div className="flex items-center gap-2 min-w-0 flex-1">
        <Button
          variant="ghost"
          size="icon"
          className="h-9 w-9 flex-shrink-0 text-primary"
          onClick={onOpenMenu}
          aria-label={t("nav.openMenu")}
        >
          <Menu className="h-5 w-5" />
        </Button>
        <div className="min-w-0 flex-1 overflow-hidden">
          <AppBreadcrumb />
        </div>
      </div>
      <div className="flex items-center gap-1 flex-shrink-0">
        <span data-tour="notification-bell">
          <NotificationBell />
        </span>
        <UserMenu model={model} variant="compact" />
      </div>
    </header>
  );
}
